<scitis-app-global-page-header [pageTitle]="'API configuration'">
  <ng-template #filterElement>
    <button (click)="onAddEndpoint()" [disabled]="!userRole.isSuperAdminRole && !userRole.isTechAdminRole"
      class="btn btn-primary">
      <span class="fa-solid fa-plus"></span>
      <span translate>New API endpoint</span>
    </button>
  </ng-template>
</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="type">
              <span translate>Endpoint URL</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="tenant">
              <span translate>Active</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="name">
              <span translate>Action</span>
            </th>

            <th class="text-right" scope="col">
              <span translate>Functions</span>
            </th>
          </tr>
        </thead>
        <tbody>

          @for (apiConfig of apiConfigs; track apiConfig) {
            <tr>
              <td>
                <strong>
                  <ngb-highlight [result]="getEndpointUrl(apiConfig)" [term]="''"></ngb-highlight>
                </strong>
              </td>
              <td>
                <span [ngClass]="getBadgeClass(apiConfig.isActive)"
                  class="badge badge-pill">
                  <ngb-highlight [result]="getStatus(apiConfig.isActive)" [term]="''"></ngb-highlight>
                </span>
              </td>
              <td>
                <ngb-highlight [result]="apiConfig.triggerQuery.name" [term]="''"></ngb-highlight>
              </td>
              <td class="text-right">
                <scitis-admin-api-configuration-action
                  (apiConfigsUpdateEvent)="onApiConfigsUpdate($event)"
                  (endpointUpdateEvent)="onEndpointUpdated($event)"
                  [apiConfigs]="apiConfigs"
                  [endpoint]="apiConfig"
                  [machine]="machine"
                  [userRole]="userRole">
                </scitis-admin-api-configuration-action>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
